export interface DeviceChoice {
  integrationId: string;
  deviceId: string;
}

export type DeviceChange = { kind: 'none' } | { kind: 'set'; choice: DeviceChoice } | { kind: 'clear' };

/** One Select value for a device: an installation numbers its own devices, so the id alone is not enough. A uuid has no colon, so the first one splits it. */
export function encodeDeviceChoice({ integrationId, deviceId }: DeviceChoice): string {
  return `${integrationId}:${deviceId}`;
}

export function decodeDeviceChoice(value: string): DeviceChoice | null {
  const at = value.indexOf(':');
  if (at <= 0 || at === value.length - 1) return null;
  return { integrationId: value.slice(0, at), deviceId: value.slice(at + 1) };
}

export function deviceOptionLabel({ deviceId, integrationName }: { deviceId: string; integrationName: string }): string {
  return `${deviceId} · ${integrationName}`;
}

/** What saving the truck form must do to the truck's device, given the value it opened with and the one chosen. */
export function deviceChange(previous: string | undefined, next: string | undefined): DeviceChange {
  if (previous === next) return { kind: 'none' };
  const choice = next ? decodeDeviceChoice(next) : null;
  return choice ? { kind: 'set', choice } : { kind: 'clear' };
}
